export default __webpack_public_path__ + "static/media/rhb-color.12cd90a3.svg";